export default "__VITE_ASSET__BVThVewL__"